import { apiList } from "../api/apiList";
import axiosInstance2 from "../api/axiosInstance2";

const goalResultService = {
  getWithdrawal : (id) => axiosInstance2.get(`${apiList.getWithdrawalApi}/${id}`),
  getDeposite : (id) => axiosInstance2.get(`${apiList.getDepositeApi}/${id}`),
  processWithdrawal : (data) => axiosInstance2.post(apiList.processWithdrawalApi, data),
  processDeposite : (data) => axiosInstance2.post(apiList.processDepositeApi, data),
  getBankAccount : () => axiosInstance2.get(apiList.bankAccountApi),
  getTransactionHistory : (data) => axiosInstance2.post(apiList.getTransactionHistoryApi, data),
};

export default goalResultService;
